import styled from 'styled-components';
import TextLink from '../TextLink/TextLink';
import Arrow from '../../../images/Arrow_link_back.svg';

export const ProductsLink = styled(TextLink)`
  font-weight: 600 !important;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  padding: 1rem 0 2rem 1rem;
  width: fit-content;
  margin-bottom: 0;

  &:hover {
    text-decoration: underline;
  }
  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 10px;
    height: 8px;
    left: 0px;
    top: 18px;
    background: url(${Arrow}) no-repeat scroll 0 0 transparent;
  }
`;
